import BeautyInsider from 'components/Content/BeautyInsider/BeautyInsider';
import { withBeautyInsiderProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderProps';

export default withBeautyInsiderProps(BeautyInsider);
